// THOSE VALUES HAVE TO MATCHED WITH THE PunchApprovalTypeList ENUM IN KONEK

/*Events*/
export const EMPLOYEE_CHANGE_EV = { index: 1, key: 'employeeCode' };
export const STARTDATE_CHANGE_EV = { index: 2, key: 'realStartTime' };
export const ENDDATE_CHANGE_EV = { index: 3, key: 'realEndTime' };
export const DEPARTMENT_CHANGE_EV = { index: 4, key: 'departmentCode' };
export const JOBTITLE_CHANGE_EV = { index: 5, key: 'jobTitle' };
export const PAYCODE_CHANGE_EV = { index: 6, key: 'payCode' };
export const ABCPROJECT_CHANGE_EV = { index: 7, key: 'abcProjectCode' };
export const PAYPROJECT_CHANGE_EV = { index: 8, key: 'payProjectCode' };
export const PAYACTIVITY_CHANGE_EV = { index: 9, key: 'payActivityCode' };
export const WORKORDER_CHANGE_EV = { index: 10, key: 'workOrder' };
export const WORKRANGE_CHANGE_EV = { index: 11, key: 'workRangeId' };
export const ISOVERTIMEAFTER_EV = { index: 12, key: 'isOvertimeAfter' };
export const ISOVERTIMEBEFORE_EV = { index: 13, key: 'isOvertimeBefore' };
export const ISAPPROVED_EV = { index: 14, key: 'isApproved' };

/*Actions*/
export const ONLOAD = { index: 99, key: '' };
export const ABCACTIVITY_FILL = { index: 100, key: '' };

export function getIndex(key) {
    switch (key) {
        case EMPLOYEE_CHANGE_EV.key:
            return EMPLOYEE_CHANGE_EV.index;
        case STARTDATE_CHANGE_EV.key:
            return STARTDATE_CHANGE_EV.index;
        case ENDDATE_CHANGE_EV.key:
            return ENDDATE_CHANGE_EV.index;
        case DEPARTMENT_CHANGE_EV.key:
            return DEPARTMENT_CHANGE_EV.index;
        case JOBTITLE_CHANGE_EV.key:
            return JOBTITLE_CHANGE_EV.index;
        case PAYCODE_CHANGE_EV.key:
            return PAYCODE_CHANGE_EV.index;
        case ABCPROJECT_CHANGE_EV.key:
            return ABCPROJECT_CHANGE_EV.index;
        case PAYPROJECT_CHANGE_EV.key:
            return PAYPROJECT_CHANGE_EV.index;
        case PAYACTIVITY_CHANGE_EV.key:
            return PAYACTIVITY_CHANGE_EV.index;
        case WORKORDER_CHANGE_EV.key:
            return WORKORDER_CHANGE_EV.index;
        case WORKRANGE_CHANGE_EV.key:
            return WORKRANGE_CHANGE_EV.index;
        case ISOVERTIMEAFTER_EV.key:
            return ISOVERTIMEAFTER_EV.index;
        case ISOVERTIMEBEFORE_EV.key:
            return ISOVERTIMEBEFORE_EV.index;
        case ISAPPROVED_EV.key:
            return ISAPPROVED_EV.index;
        default:
            return 0;
    }
}